import './AttemptBoard.css';
import TimingClock from '../../components/TimingClock';
import Bulbs from '../../components/Bulbs';
import {
  liftsSelector,
  eventsSelector,
  protocolsSelector,
} from '../../orm/selectors';
import { computeCallingOrder } from '../../rules/callingOrder';
import { formatName } from '../../common';

import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import { createSelector } from 'reselect';
import { find, get, map, pick } from 'lodash';

const DeclarationRows = ({ declaration }) => (
  <div className="clearfix">
    <span
      style={{
        color: 'red',
        fontSize: '8em',
        fontWeight: 'bolder',
      }}
    >
      {declaration.attemptNumber}
      <span style={{ fontSize: '50%' }}> Att.</span>
    </span>
    <span
      style={{
        color: 'red',
        fontSize: '8em',
        fontWeight: 'bolder',
        float: 'right',
      }}
    >
      {declaration.weight}
      <span style={{ fontSize: '50%' }}>kg</span>
    </span>
  </div>
);

const AthleteRows = ({ athlete }) => (
  <Fragment>
    <div className="clearfix" style={{ textAlign: 'center' }}>
      <span
        style={{
          fontSize: '6em',
          textAlign: 'center',
          fontWeight: 'bolder',
        }}
      >
        {formatName(get(athlete, 'entry'))}
      </span>
    </div>
    <div className="clearfix">
      <span style={{ color: 'magenta', fontSize: '8em' }}>
        {athlete.startNumber}
      </span>
      <span
        style={{
          color: 'lightgreen',
          fontSize: '8em',
          fontWeight: 'bold',
          float: 'right',
        }}
      >
        {map(get(athlete.entry, 'teams', []), 'abbreviation').join(', ')}
      </span>
    </div>
  </Fragment>
);

const AttemptBoard = ({ currentAthlete, currentDeclaration, timingClock }) => {
  return (
    <main className="nosturi attempt-board page">
      <Bulbs />
      <div className="clearfix" style={{ textAlign: 'center' }}>
        <div
          style={{
            display: 'inline-block',
            color: 'white',
            background: 'blue',
          }}
        >
          <TimingClock {...timingClock} size="massive" />
        </div>
      </div>
      {currentDeclaration && (
        <DeclarationRows declaration={currentDeclaration} />
      )}
      {currentAthlete && <AthleteRows athlete={currentAthlete} />}
    </main>
  );
};

AttemptBoard.slug = 'attempt-board';
AttemptBoard.title = 'Attempt board';

const mapStateToProps = () => {
  const callingOrderSelector = createSelector(
    ({ protocol }) => get(protocol, 'athletes', []),
    ({ lift }) => get(lift, 'id', -1),
    ({ event }) => get(event, 'mode', 'default'),
    (athletes, liftId, mode) => {
      if (!athletes.length || liftId === -1) return [];
      return computeCallingOrder(athletes, liftId, mode);
    },
  );

  return ({ venue, orm }) => {
    const lifts = liftsSelector(orm);
    const protocols = protocolsSelector(orm);
    const events = eventsSelector(orm);
    const [currentEvent] = events;

    const currentProtocol = find(protocols, [
      'uuid',
      get(venue.competition, 'current.protocol'),
    ]);
    const currentLift = find(lifts, [
      'uuid',
      get(venue.competition, 'current.lift'),
    ]);

    const [currentAthlete] = callingOrderSelector({
      protocol: currentProtocol,
      lift: currentLift,
      event: currentEvent,
    });

    return {
      currentDeclaration: get(currentAthlete, [
        'lastDeclarationByLiftId',
        get(currentLift, 'id'),
      ]),
      currentAthlete,
      ...pick(venue.competition, 'timingClock'),
    };
  };
};

export default connect(mapStateToProps)(AttemptBoard);



// WEBPACK FOOTER //
// ./src/displays/AttemptBoard/AttemptBoard.js